import { createAsyncThunk } from "@reduxjs/toolkit";

import type { NapiClient } from "@app/services/api";
import { Transaction } from "@app/tracking/error-tracking";
import type { CheckoutReduxStateV2 } from "@app/types/checkout-v2-types";

import {
  pollCartV2Begin,
  pollCartV2Failure,
  pollCartV2Success
} from "../slices/cart";

interface ThunkConfig {
  state: CheckoutReduxStateV2;
}

interface DiscountCodeActionParams {
  api: NapiClient;
  discount_code: string;
}

export const addDiscountCode = createAsyncThunk<
  Promise<any>,
  DiscountCodeActionParams,
  ThunkConfig
>(
  "checkout/addDiscountCode",
  (
    { api, discount_code }: DiscountCodeActionParams,
    { getState, dispatch }
  ) => {
    const {
      cart: { id }
    } = getState();
    dispatch(pollCartV2Begin());

    return api
      .addDiscountCodeV2(id, discount_code)
      .then(async () => {
        const response = await api.pollCartV2(id);
        dispatch(pollCartV2Success(response!));
      })
      .catch(error => {
        error.transaction = Transaction.ADD_DISCOUNT_CODE;
        dispatch(pollCartV2Failure(error));
        throw error;
      });
  }
);

export const removeDiscountCode = createAsyncThunk<
  Promise<any>,
  DiscountCodeActionParams,
  ThunkConfig
>(
  "checkout/removeDiscountCode",
  (
    { api, discount_code }: DiscountCodeActionParams,
    { getState, dispatch }
  ) => {
    const {
      cart: { id }
    } = getState();
    dispatch(pollCartV2Begin());

    return api
      .removeDiscountCodeV2(id, discount_code)
      .then(async () => {
        const response = await api.pollCartV2(id);
        dispatch(pollCartV2Success(response!));
      })
      .catch(error => {
        error.transaction = Transaction.REMOVE_DISCOUNT_CODE;
        dispatch(pollCartV2Failure(error));
        throw error;
      });
  }
);
